import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=41d60065&scoped=true&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=41d60065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d60065",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d60065')) {
      api.createRecord('41d60065', component.options)
    } else {
      api.reload('41d60065', component.options)
    }
    module.hot.accept("./FormItem.vue?vue&type=template&id=41d60065&scoped=true&", function () {
      api.rerender('41d60065', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/FormItem.vue"
export default component.exports